import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import useWholesaleWhatsApp from "../hooks/useWholesaleWhatsApp";

/**
 * @param {{ title: string, flavor: string, quantity: number }[] | undefined} items
 */
export default function WholesaleWhatsAppBanner({ items, sx }) {
    const { openWholesaleWhatsApp, loading } = useWholesaleWhatsApp(items);

    return (
        <Box
            role="button"
            tabIndex={0}
            onClick={openWholesaleWhatsApp}
            onKeyDown={(e) => {
                if (loading) return;
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    openWholesaleWhatsApp();
                }
            }}
            sx={{
                p: { xs: 2, md: 2.5 },
                borderRadius: 3,
                background: "linear-gradient(135deg, #1a7f4b, #25D366)",
                color: "#fff",
                cursor: loading ? "wait" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: 2,
                boxShadow: "0 8px 24px rgba(37, 211, 102, 0.35)",
                transition: "transform 0.2s, box-shadow 0.2s",
                opacity: loading ? 0.85 : 1,
                "&:hover": loading
                    ? {}
                    : {
                          transform: "translateY(-1px)",
                          boxShadow: "0 12px 28px rgba(37, 211, 102, 0.45)",
                      },
                ...sx,
            }}
        >
            {loading ? (
                <CircularProgress size={28} sx={{ color: "#fff", flexShrink: 0 }} />
            ) : (
                <WhatsAppIcon sx={{ fontSize: 32, flexShrink: 0 }} />
            )}
            <Typography sx={{ fontWeight: 700, fontSize: { xs: 15, md: 16 } }}>
                Comprar com preço de atacado via WhatsApp.
            </Typography>
        </Box>
    );
}
